import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
  apiKey: process.env.VUE_APP_BUG_SNAG,
  plugins: [new BugsnagPluginVue()],
  appVersion: '1.0.623',
  // Configure user props
  user: {
    id: '',
    email: ''
  }
})

export default Bugsnag



// WEBPACK FOOTER //
// ./src/plugins/bugsnag.js